import PDFAddress from "./PDFAddress";
import { Row, Col } from "antd";
import "../css/loadprint.css";

function PDFAddressMain({ dataTabelB }) {

  // แบ่งข้อมูลเป็นคู่ ๆ 1-ซ้าย, 2-ขวา, 3-ซ้าย, 4-ขวา
  const pairs = [];
  for (let i = 0; i < dataTabelB.length; i += 2) {
    pairs.push([dataTabelB[i], dataTabelB[i + 1] || null]);
  }

  return (
    <>
      {pairs.map((pair, index) => (
        <div key={index} style={{ padding: "15px 40px", pageBreakInside: "avoid" }}>
          <Row gutter={[0, 4]}>

            {/* ซ้าย */}
            <Col span={12}>
              {pair[0] && (
                <PDFAddress dataTabelB={pair[0]} />
              )}
            </Col>

            {/* ขวา */}
            <Col span={12}>
              {pair[1] && (
                <PDFAddress dataTabelB={pair[1]} />
              )}
            </Col>

          </Row>
        </div>
      ))}
    </>
  );
}

export default PDFAddressMain;